export default __webpack_public_path__ + "static/media/564.5ab653f6.png";